import styled, { css } from 'styled-components';

import { Grid, Card } from '@material-ui/core';

export const Warpper = styled(Grid).attrs({
  container: true,
  spacing: 2,
  justify: 'center',
  alignItems: 'center',
})``;

export const List = styled(Grid).attrs({
  item: true
})`
  button:not(:first-child) {
    margin-top: 2rem;
  }
`

export const WrapperList = styled(Card)`
  width: 38rem;

  ${({ secondary }) => secondary && css`
    width: 70rem;
  `}
`
